import BkashIcon from '../../assets/icons/payment-providers/BkashIcon';
import NagadIcon from '../../assets/icons/payment-providers/NagadIcon';
import { FINPSP_BANK_LABELS, FINPSP_BANK_TYPE } from '../../constants/finpsp';
import type { PaymentProvider } from '../../types/payment';

export const finpspPaymentProviders: PaymentProvider[] = [
  { value: FINPSP_BANK_TYPE.BKASH, label: FINPSP_BANK_LABELS[FINPSP_BANK_TYPE.BKASH], icon: BkashIcon },
  { value: FINPSP_BANK_TYPE.NAGAD, label: FINPSP_BANK_LABELS[FINPSP_BANK_TYPE.NAGAD], icon: NagadIcon },
];
